import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=06ccba2d&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=06ccba2d&prod&lang=scss"
import style1 from "./Payment.vue?vue&type=style&index=1&id=06ccba2d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ccba2d",
  null
  
)

export default component.exports